import Vue from "vue";
Vue.prototype.errMessage = function(err, title = "错误提示") {
  if (!err) return;
  this.$notify.error({
    title,
    message: err.message
  });
};

Vue.prototype.successMsg = function(message = "操作成功") {
  this.$message({
    message,
    type: "success",
    showClose: true
  });
};

/**
 * 过滤按钮类型
 */
export function flat2(menus) {
  for (var menu of menus) {
    menu["nodes"] = menu["nodes"].filter(item => item["type"] == "MENU");
    flat2(menu["nodes"]);
  }
  return menus;
}

export function timeSubStr(str) {
  const index = str.indexOf(" ");
  return str.substring(0, index);
}

export function errMessage(arr) {
  return arr.join("<br/>");
}

// 递归寻找第一个路径
export function findPath(allMenus) {
  for (let item of allMenus) {
    if (item.action) {
      return item.action;
    }
    let action = findPath(item.nodes);
    if (action) {
      return action;
    }
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/utils/index.js